import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";

export default function LegalPage({ eyebrow, title, updated, intro, sections, seoTitle, seoDesc }) {
  return (
    <>
      <SEO title={seoTitle} description={seoDesc} />
      <section className="mx-auto max-w-3xl px-5 pt-36 pb-24 md:pt-44" data-testid="legal-page">
        <p className="label mb-6 text-wine">{eyebrow}</p>
        <h1 className="font-display text-4xl leading-[1.05] md:text-6xl">{title}</h1>
        {updated && <p className="mt-4 font-mono text-xs uppercase tracking-[0.14em] text-muted-foreground">Last updated · {updated}</p>}
        {intro && <p className="mt-8 text-muted-foreground md:text-lg">{intro}</p>}
        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.03}>
              <div>
                <h2 className="font-display text-2xl">{s.h}</h2>
                <div className="mt-3 space-y-3 leading-relaxed text-muted-foreground">
                  {s.body.map((p, k) => <p key={k}>{p}</p>)}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
